import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { remind } from 'actions/user';
import { SaveButton } from '@salesperformanceint/e4shared';
import { setSaving } from 'actions/ui';

export const Password = ({ history }) => {
    const dispatch = useDispatch();

    const [email, setEmail] = React.useState('');
    const [sent, setSent] = React.useState(false);

    const emailField = React.useRef(null);

    const { errorMessage } = useSelector(state => state.user);
    const { saving } = useSelector(state => state.ui);

    React.useEffect(() => {
        emailField?.current && emailField?.current.focus();
    }, [emailField?.current]);

    React.useEffect(() => {
        dispatch(setSaving(false));
    }, [errorMessage]);

    const checkSubmit = (e, callback) => {
        if (e.key === 'Enter') {
            callback();
        }
    };

    const remindMe = () => {
        dispatch(remind(email, () => setSent(true)));
    };

    return (
        <div className="login-box">
            <div className="login-logo">
                <img alt="Richardson Sales Performance" src="/dist/img/richardson_sp.png" loading="lazy" />
            </div>
            <div className="login-body">
                {sent && !errorMessage ? (
                    <>
                        <p>We have sent you an email containing a link.</p>
                        <p>Please click on the link to reset your password.</p>
                        <p>Thanks.</p>
                    </>
                ) : (
                    <>
                        <p>Enter your email in order to reset your password</p>
                        {errorMessage && (
                            <p className="error">
                                <i className="fa fa-solid fa-exclamation-circle text-danger mr5" />
                                {errorMessage}
                            </p>
                        )}
                        <div className="form-group has-feedback">
                            <input
                                ref={emailField}
                                onChange={e => setEmail(e.target.value)}
                                onKeyUp={e => checkSubmit(e, remindMe)}
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                data-testid="text-email"
                            />
                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                        </div>
                        <div className="flex flex-center">
                            <div className="flex-grow">
                                <SaveButton
                                    saving={saving}
                                    setSaving={setSaving}
                                    onClick={() => remindMe()}
                                    onKeyUp={e => checkSubmit(e, remindMe)}
                                    className="btn btn-primary"
                                    data-testid="button-reset"
                                >
                                    Send password reset email
                                </SaveButton>
                            </div>
                            <button className="btn btn-link" onClick={() => history.push('/')} data-testid="button-back">
                                Back to login
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default withRouter(Password);
